// External Dependencies
import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

const MailIcon = props => (
  <SvgIcon
    viewBox="0 0 64 64"
    {...props}
  >
    <g id="Layer_1">
      <g>
        <circle
          cx="32"
          cy="32"
          fill="#77B3D4"
          r="32"
        />
      </g>
      <g>
        <g opacity="0.2">
          <path
            d="M52,44c0,2.209-1.791,4-4,4H16c-2.209,0-4-1.791-4-4V24c0-2.209,1.791-4,4-4h32c2.209,0,4,1.791,4,4V44z"
            fill="#231F20"
          />
        </g>
        <g>
          <path
            d="M52,42c0,2.209-1.791,4-4,4H16c-2.209,0-4-1.791-4-4V22c0-2.209,1.791-4,4-4h32c2.209,0,4,1.791,4,4V42z"
            fill="#E0E0D1"
          />
        </g>
        <g opacity="0.2">
          <g>
            <path
              d="M35.524,30.185c-1.938-2.146-5.109-2.146-7.047,0L13.05,43.228c-0.18,0.199-0.328,0.393-0.461,0.585C13.29,45.119,14.549,46,16,46h32c1.451,0,2.71-0.881,3.411-2.187c-0.133-0.191-0.281-0.385-0.461-0.585L35.524,30.185z"
              fill="#231F20"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M35.524,32c-1.938-1.9-5.109-1.9-7.047,0L13.05,43.546c-0.18,0.176-0.328,0.348-0.461,0.517C13.29,45.22,14.549,46,16,46h32c1.451,0,2.71-0.78,3.411-1.936c-0.133-0.169-0.281-0.341-0.461-0.517L35.524,32z"
              fill="#E0E0D1"
            />
          </g>
        </g>
        <g opacity="0.2">
          <g>
            <path
              d="M12.589,20.187C13.29,18.881,14.549,18,16,18h32c1.451,0,2.71,0.881,3.411,2.187c-0.133,0.191-0.281,0.385-0.461,0.585L35.524,33.815c-1.938,2.146-5.109,2.146-7.047,0L12.589,20.187z"
              fill="#231F20"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M28.476,32c1.938,1.9,5.109,1.9,7.047,0L50.95,20.454c0.18-0.176,0.328-0.348,0.461-0.517      C50.71,18.78,49.451,18,48,18H16c-1.451,0-2.71,0.78-3.411,1.936c0.133,0.169,0.281,0.341,0.461,0.517L28.476,32z"
              fill="#FFFFFF"
            />
          </g>
        </g>
      </g>
    </g>
    <g id="Layer_2" />
  </SvgIcon>
);

export default MailIcon;



/** WEBPACK FOOTER **
 ** ./src/shared/icons/mail.js
 **/